var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.51 22.8L18.9767 1.70667C18.35 0.64 17.2433 0 15.99 0C14.7367 0 13.63 0.64 13.0167 1.70667L0.47 22.8C-0.156667 23.8933 -0.156667 25.1867 0.47 26.2667C1.09667 27.3467 2.21667 28 3.45667 28H28.5367C29.79 28 30.91 27.3467 31.5233 26.2667C32.1367 25.1867 32.1367 23.8933 31.51 22.8ZM17.3233 21.3333C17.3233 22.0697 16.7264 22.6667 15.99 22.6667C15.2536 22.6667 14.6567 22.0697 14.6567 21.3333C14.6567 20.597 15.2536 20 15.99 20C16.7264 20 17.3233 20.597 17.3233 21.3333ZM17.3233 16C17.3233 16.7364 16.7264 17.3333 15.99 17.3333C15.2536 17.3333 14.6567 16.7364 14.6567 16V10.6667C14.6567 9.93029 15.2536 9.33333 15.99 9.33333C16.7264 9.33333 17.3233 9.93029 17.3233 10.6667V16Z",
    fill: "#F0910D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warningAlert.0d3ec65b3188fb98304b535233b70d79.svg";
export { ForwardRef as ReactComponent };